import { Dayjs } from "dayjs";
import { LloCasesToFormItem } from "../../../../api";

export type SortableColumn =
  | "caseName"
  | "stage"
  | "raa"
  | "ap"
  | "complaintFiledDate"
  | "formByDate"
  | "daysPastFormBy"
  | "lloExpiration";

export type SortDirection = "asc" | "desc";

export type SortRule = {
  column: SortableColumn;
  direction: SortDirection;
};

export type HeadCell = {
  id: SortableColumn;
  label: string;
  widthPct: number;
};

export type LloCasesToFormFiltersState = {
  caseName: string;
  stage: string;
  raa: string;
  ap: string;
  searchTerm: string;
  complaintFiledFrom: Dayjs | null;
  complaintFiledTo: Dayjs | null;
  formByFrom: Dayjs | null;
  formByTo: Dayjs | null;
};

export type FilterFieldKey = Exclude<
  keyof LloCasesToFormFiltersState,
  "complaintFiledFrom" | "complaintFiledTo" | "formByFrom" | "formByTo"
>;

export const EMPTY_FILTERS: LloCasesToFormFiltersState = {
  caseName: "",
  stage: "",
  raa: "",
  ap: "",
  searchTerm: "",
  complaintFiledFrom: null,
  complaintFiledTo: null,
  formByFrom: null,
  formByTo: null,
};

export const FILTER_FIELD_LABELS: Record<FilterFieldKey, string> = {
  caseName: "Case",
  stage: "Stage",
  raa: "RAA",
  ap: "AP",
  searchTerm: "Search",
};

export const SORT_FIELD_OPTIONS: { value: SortableColumn; label: string }[] = [
  { value: "daysPastFormBy", label: "Days past form by" },
  { value: "formByDate", label: "Form by" },
  { value: "complaintFiledDate", label: "Complaint filed" },
  { value: "caseName", label: "Case name" },
  { value: "stage", label: "Stage" },
  { value: "raa", label: "RAA" },
  { value: "ap", label: "AP" },
  { value: "lloExpiration", label: "LLO expiration" },
];

export const SORT_DIRECTION_OPTIONS: { value: SortDirection; label: string }[] = [
  { value: "asc", label: "Ascending" },
  { value: "desc", label: "Descending" },
];

export const DEFAULT_SORT_RULES: SortRule[] = [
  { column: "daysPastFormBy", direction: "desc" },
];

export type LloCasesToFormRow = LloCasesToFormItem;
